/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ReportRunResponse,
    ReportRunResponseFromJSON,
    ReportRunResponseToJSON,
    ReportingTimeBucket,
    ReportingTimeBucketFromJSON,
    ReportingTimeBucketToJSON,
    RunReportRequest,
    RunReportRequestFromJSON,
    RunReportRequestToJSON,
} from '../models';

export interface InternalReportsRunReportRequest {
    firmId?: string;
    runReportRequest?: RunReportRequest;
}

export interface InternalReportsUsageReportRequest {
    firmId?: string;
    period?: ReportingTimeBucket;
}

/**
 * 
 */
export class InternalReportsApi extends runtime.BaseAPI {

    /**
     */
    async internalReportsRunReportRaw(requestParameters: InternalReportsRunReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportRunResponse>> {
        const queryParameters: any = {};

        if (requestParameters.firmId !== undefined) {
            queryParameters['firmId'] = requestParameters.firmId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/InternalReports/run-report`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RunReportRequestToJSON(requestParameters.runReportRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportRunResponseFromJSON(jsonValue));
    }

    /**
     */
    async internalReportsRunReport(requestParameters: InternalReportsRunReportRequest, initOverrides?: RequestInit): Promise<ReportRunResponse> {
        const response = await this.internalReportsRunReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async internalReportsUploadDownloadReportRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/InternalReports/upload-download-report`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async internalReportsUploadDownloadReport(initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.internalReportsUploadDownloadReportRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async internalReportsUsageReportRaw(requestParameters: InternalReportsUsageReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.firmId !== undefined) {
            queryParameters['firmId'] = requestParameters.firmId;
        }

        if (requestParameters.period !== undefined) {
            queryParameters['period'] = requestParameters.period;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/InternalReports/usage-report`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async internalReportsUsageReport(requestParameters: InternalReportsUsageReportRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.internalReportsUsageReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
